import { motion } from "framer-motion";
import {
    BadgeCheck,
    FileCheck2,
    Banknote,
    Repeat,
    ShieldCheck,
    Globe2,
    Sparkles,
    Stethoscope,
    FileSignature,
    Wallet,
    Umbrella,
    Car,
} from "lucide-react";

const WHY = [
    {
        icon: BadgeCheck,
        title: "Проверени автомобили",
        desc: "Всеки автомобил преминава пълна техническа диагностика и оглед от наши специалисти.",
    },
    {
        icon: FileCheck2,
        title: "Прозрачна история",
        desc: "Удостоверен пробег и документирана сервизна история. Без скрити детайли.",
    },
    {
        icon: Banknote,
        title: "Гъвкаво финансиране",
        desc: "Партньори сме с водещи банки. Бърза одобрителна процедура и индивидуални условия.",
    },
    {
        icon: Repeat,
        title: "Бартер",
        desc: "Заменете настоящия си автомобил като част от стойността на новата покупка.",
    },
    {
        icon: ShieldCheck,
        title: "Удължена гаранция",
        desc: "Предлагаме разширени гаранционни планове за допълнително спокойствие.",
    },
    {
        icon: Globe2,
        title: "Внос по поръчка",
        desc: "Професионално намиране на конкретен автомобил от утвърдени европейски пазари.",
    },
];

const SERVICES = [
    { icon: Sparkles, title: "Детайлинг", desc: "Професионално възстановяване и защита на повърхности." },
    { icon: Stethoscope, title: "Диагностика", desc: "Пълна техническа диагностика с фирмено оборудване." },
    { icon: FileSignature, title: "Регистрация", desc: "Поемаме целия процес по пререгистрация и документи." },
    { icon: Umbrella, title: "Застраховане", desc: "Каско, Гражданска и пакетни решения за всеки клиент." },
];

function Card({ Icon, title, desc, index }) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: index * 0.06 }}
            whileHover={{ y: -6 }}
            className="group relative bg-surface border border-line rounded-2xl p-8 hover:border-gold/40 transition-all duration-500 gold-border-anim"
            data-testid={`why-card-${index}`}
        >
            <div className="w-14 h-14 rounded-2xl bg-gold/10 border border-gold/20 flex items-center justify-center mb-6 group-hover:bg-gold/20 transition-colors">
                <Icon size={26} className="text-gold" />
            </div>
            <h3 className="font-display text-2xl mb-3">{title}</h3>
            <p className="text-ink-muted leading-relaxed">{desc}</p>
        </motion.div>
    );
}

export function WhyChooseUs() {
    return (
        <section className="relative py-28 lg:py-36" data-testid="why-section">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="max-w-2xl mb-16">
                    <span className="block text-gold text-[11px] uppercase tracking-[0.32em] mb-5">
                        Защо Konstantin
                    </span>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tightest">
                        Защо да изберете Konstantin.mobile.bg
                    </h2>
                </div>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {WHY.map((w, i) => (
                        <Card key={w.title} Icon={w.icon} title={w.title} desc={w.desc} index={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}

export function Services() {
    return (
        <section
            id="services"
            className="relative py-28 lg:py-36"
            data-testid="services-section"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-6">
                    <div>
                        <span className="block text-gold text-[11px] uppercase tracking-[0.32em] mb-5">
                            Пълно обслужване
                        </span>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tightest">
                            Нашите услуги
                        </h2>
                    </div>
                    <p className="max-w-md text-ink-muted leading-relaxed">
                        От намирането на правилния автомобил до неговата регистрация и грижа —
                        всичко на едно място.
                    </p>
                </div>
                <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
                    {SERVICES.map((s, i) => (
                        <Card key={s.title} Icon={s.icon} title={s.title} desc={s.desc} index={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}
